/*
 * 10-minute cart countdown. Deadline lives in sessionStorage so it survives
 * the Section Rendering API re-rendering the drawer on every cart update.
 */
(function () {
  var DURATION = 10 * 60;
  var STORAGE_KEY = 'm-cart-timer-deadline';

  function getDeadline() {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) return parseInt(stored, 10);
    var deadline = Date.now() + DURATION * 1000;
    sessionStorage.setItem(STORAGE_KEY, deadline);
    return deadline;
  }

  function clearDeadline() {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  function format(seconds) {
    var m = Math.floor(seconds / 60);
    var s = seconds % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function tick(valueEl) {
    var deadline = getDeadline();
    var remaining = Math.max(0, Math.round((deadline - Date.now()) / 1000));
    valueEl.textContent = format(remaining);
    if (remaining <= 0) {
      clearDeadline();
      getDeadline();
    }
  }

  function boot() {
    var el = document.querySelector('[data-m-cart-timer]');
    if (!el || el.hasAttribute('hidden')) return;
    var valueEl = el.querySelector('[data-m-cart-timer-value]');
    if (!valueEl || el.dataset.mCartTimerReady === '1') return;
    el.dataset.mCartTimerReady = '1';
    tick(valueEl);
    setInterval(function () { tick(valueEl); }, 1000);
  }

  function onCartEmpty() {
    var bar = document.querySelector('[data-promo-count]');
    var count = bar ? parseInt(bar.dataset.promoCount, 10) : null;
    if (count === 0) clearDeadline();
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('cart:updated', function () { boot(); onCartEmpty(); });
  document.addEventListener('cart:refresh', function () { boot(); onCartEmpty(); });

  var target = document.getElementById('MinimogCartDrawer') || document.body;
  new MutationObserver(boot).observe(target, { childList: true, subtree: true });
})();
